export default {
    when() {
        return $('nav').length > 0;
    },

    mounted() {
        const body = document.body;
        const stickySegmentNavigation = document.querySelector(
            '#sticky-segment-navigation'
        );

        // Initial setup for body classes
        body.classList.add('nav--show', 'nav--top');

        let prevScrollPos = window.pageYOffset;

        function toggleNavigation(show) {
            if (show) {
                body.classList.add('nav--show');
                body.classList.add('nav--top');
            } else {
                body.classList.remove('nav--show', 'nav--top');
            }
        }

        function handleScroll() {
            const currentScrollPos = window.scrollY;

            // Show navigation when scrolling up or at the top
            if (prevScrollPos > currentScrollPos || currentScrollPos === 0) {
                if (currentScrollPos < 500 || currentScrollPos === 0) {
                    toggleNavigation(true);
                } else {
                    toggleNavigation(true);
                }
            } else {
                // Hide navigation when scrolled down beyond 500px
                if (currentScrollPos > 500) {
                    toggleNavigation(false);
                }
            }

            // Ensure we don't flood with adding class requests
            clearTimeout(window.scrollTimer);
            window.scrollTimer = setTimeout(() => {
                body.classList.add('nav--show');
            }, 2000);

            prevScrollPos = currentScrollPos;
        }

        window.addEventListener('scroll', handleScroll);

        // Toggle language selection
        const langToggle = document.querySelector(
            '.wpml-ls-current-language > a'
        );
        if (langToggle) {
            langToggle.addEventListener('click', function (e) {
                e.preventDefault();
                this.parentElement.classList.toggle('actif');
            });
        }
    },
};
